var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "check-detail" } },
    [
      _c("div", { staticClass: "drop-shadow-with-top" }, [
        _c("table", { attrs: { id: "header" } }, [
          _c("tr", [
            _vm._m(0),
            _c("td", { attrs: { id: "title", rowspan: "2" } }, [
              _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      return _vm.setIsCheckDetailsShown(
                        !_vm.isCheckDetailsShown
                      )
                    },
                  },
                },
                [
                  _vm._v(" " + _vm._s(_vm.detail.guestName) + " "),
                  _vm.isCheckDetailsShown
                    ? _c("img", {
                        staticClass: "caret",
                        attrs: {
                          src: require("@/assets/images/caret-down.png"),
                        },
                      })
                    : _c("img", {
                        staticClass: "caret",
                        attrs: {
                          src: require("@/assets/images/caret-right.png"),
                        },
                      }),
                ]
              ),
            ]),
          ]),
          _vm._m(1),
        ]),
      ]),
      _c("transition", { attrs: { name: "fade-slide" } }, [
        _vm.isCheckDetailsShown
          ? _c(
              "div",
              { staticClass: "drop-shadow-sides", attrs: { id: "orders" } },
              _vm._l(_vm.detail.orderItems, function (order) {
                return _c(
                  "table",
                  { key: order.orderItemId },
                  [
                    _c("tr", [
                      _c("td", { staticClass: "label-column" }, [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                order.quantity +
                                  "\xa0\xa0\xa0" +
                                  order.menuItemName
                              ) +
                              " "
                          ),
                        ]),
                        order.components !== null && order.components.length > 0
                          ? _c("div", [
                              _c(
                                "ul",
                                _vm._l(order.components, function (component) {
                                  return _c(
                                    "li",
                                    {
                                      key: component.orderItemId,
                                      staticClass: "subitem-label",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(component.componentName) +
                                          " "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ])
                          : _vm._e(),
                        order.servingOptions !== null &&
                        order.servingOptions.length > 0
                          ? _c("div", [
                              _c(
                                "ul",
                                _vm._l(
                                  order.servingOptions,
                                  function (servingOption) {
                                    return _c(
                                      "li",
                                      {
                                        key: servingOption.servingOptionId,
                                        staticClass: "subitem-label",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              servingOption.servingOptionName
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _c("td", { staticClass: "value-column" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("toCurrency")(order.price * order.quantity)
                          )
                        ),
                      ]),
                    ]),
                    _vm._l(
                      _vm.filterAdjustments(order.adjustments),
                      function (adjustment) {
                        return _c("tr", { key: adjustment.adjustmentId }, [
                          _c(
                            "td",
                            { staticClass: "label-column adjustment indented" },
                            [_vm._v(_vm._s(adjustment.adjustmentReasonName))]
                          ),
                          _c("td", { staticClass: "value-column adjustment" }, [
                            _vm._v(
                              "(" +
                                _vm._s(
                                  _vm._f("toCurrency")(adjustment.appliedAmount)
                                ) +
                                ")"
                            ),
                          ]),
                        ])
                      }
                    ),
                  ],
                  2
                )
              }),
              0
            )
          : _vm._e(),
      ]),
      _c("TotalDetail", { attrs: { isTipVisible: false } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("div", {
        staticClass: "sprite folded-corner",
        attrs: { id: "corner-img" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [_c("td", { attrs: { id: "corner-img-spacer" } })])
  },
]
render._withStripped = true

export { render, staticRenderFns }